var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.054,
    height: 105,
    viewBox: "0 0 170.054 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f18aa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "api",
    transform: "translate(-130 -2188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_smartphone_24px",
    d: "M62.273,1.048,14.545,1A9.574,9.574,0,0,0,5,10.545V96.455A9.574,9.574,0,0,0,14.545,106H62.273a9.574,9.574,0,0,0,9.545-9.545V10.545A9.533,9.533,0,0,0,62.273,1.048Zm0,85.861H14.545V20.091H62.273Z",
    transform: "translate(177.186 2187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_keyboard_return_24px",
    d: "M74.454,10.262V27.31H18.323l15.258-15.3L27.572,6,2,31.572,27.572,57.144l6.009-6.009-15.258-15.3H82.978V10.262Z",
    transform: "translate(128 2228.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_keyboard_return_24px-2",
    "data-name": "ic_keyboard_return_24px",
    className: "cls-1",
    d: "M10.524,10.262V27.31H66.655L51.4,12.009,57.406,6,82.978,31.572,57.406,57.144,51.4,51.135l15.258-15.3H2V10.262Z",
    transform: "translate(217.076 2207.335)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.85261b1d055ab8f8103268bdcce415a1.svg";
export { ForwardRef as ReactComponent };